export type IdLike = number | string;

/**
 * Converts mixed ID types to normalized number array with deduplication
 * Optimized for EHR ID processing: String|Number → Number[] + dedup + filter invalid
 */
export const normalizeIds = (values: Array<IdLike>): number[] =>
  Array.from(new Set((values ?? []).map((v) => Number(v)))).filter((n) => Number.isFinite(n));

/**
 * Sorts numbers array in ascending order (immutable)
 */
export const sortNumbers = (xs: number[]): number[] => [...xs].sort((a, b) => a - b);

/**
 * Fast array equality check for sorted numeric arrays
 * O(n) optimized comparison - more efficient than lodash.isEqual for this specific case
 */
export const areArraysEqualSorted = (a: number[], b: number[]): boolean => {
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
};
